import { render } from "./Homepage.vue?vue&type=template&id=38367fd8&scoped=true&ts=true"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"

import "./Homepage.vue?vue&type=style&index=0&id=38367fd8&scoped=true&lang=css"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38367fd8"]])

export default __exports__